import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import ErrorBoundary from "./Components/ErrorBoundary/index.jsx";
import "./Resources/Lib/Normalize/normalize.css";
import "./Resources/Sass/main.scss";
import "./Resources/Css/site.css";
import * as serviceWorker from "./serviceWorker";

const { PUBLIC_URL } = import.meta.env;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App
      basename={PUBLIC_URL}
    />
  </ErrorBoundary>
);

serviceWorker.unregister();
